<template>
  <BaseModule
    v-bind="$props"
    data-module="image-full-width"
    background-color="#fff"
  >
    <EditorLink :model="linkUrl">
      <LImage
        class="image-full-width"
        :src="deviceImages"
        :alt="deviceAlt"
      />
    </EditorLink>
  </BaseModule>
</template>

<script>
import BaseModule from './generic/BaseModule.vue';
import EditorLink from './EditorLink.vue';

export default {
  name: 'ImageFullWidth',
  components: {
    BaseModule,
    EditorLink,
  },
  props: {
    ...BaseModule.props,
    image: {
      type: String,
      default: '',
    },
    imageMobile: {
      type: String,
      default: '',
    },
    altText: {
      type: String,
      default: '',
    },
    altTextMobile: {
      type: String,
      default: '',
    },
    linkUrl: {
      type: Object,
      default: () => ({
        type: 'externalLink',
        value: '',
        openInNewTab: true,
      }),
    },
    differentMobileBackgroundImage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mobileMaxWidth: 1020,
      isMobile: false,
    };
  },
  computed: {
    deviceImages() {
      if (typeof this.differentMobileBackgroundImage !== 'undefined') {
        if (this.isMobile && this.differentMobileBackgroundImage) {
          return this.imageMobile;
        }
        return this.image;
      }
      if (this.isMobile) {
        return this.imageMobile;
      }
      return this.image;
    },
    deviceAlt() {
      if (typeof this.differentMobileBackgroundImage !== 'undefined') {
        if (this.isMobile && this.differentMobileBackgroundImage) {
          return this.altTextMobile;
        }
        return this.altText;
      }
      if (this.isMobile) {
        return this.altTextMobile;
      }
      return this.altText;
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      const isMobile = window.innerWidth <= this.mobileMaxWidth;
      this.isMobile = isMobile;
    },
  },
  metadata: {
    extends: BaseModule.metadata,
    tabs: [
      {
        name: 'content',
        label: 'Conteúdo',
        groups: [
          {
            name: 'back',
            label: 'Conteúdo', // por ser o único grupo, não terá o label da tab
            fields: [
              {
                name: 'image',
                type: 'ImageFile',
                label: 'Imagem',
                helpText: 'Largura recomendada: 1920px',
              },
              {
                name: 'altText',
                type: 'ShortText',
                label: 'Texto alternativo',
              },
              {
                name: 'differentMobileBackgroundImage',
                type: 'Checkbox',
                label: 'Usar uma imagem diferente para mobile',
              },
              {
                name: 'imageMobile',
                type: 'ImageFile',
                label: 'Imagem mobile',
                isEnabled({ differentMobileBackgroundImage }) {
                  return differentMobileBackgroundImage;
                },
              },
              {
                name: 'altTextMobile',
                type: 'ShortText',
                label: 'Texto alternativo mobile',
                isEnabled({ differentMobileBackgroundImage }) {
                  return differentMobileBackgroundImage;
                },
              },
              {
                name: 'linkUrl',
                type: 'Url',
                label: 'Link/URL (opcional)',
              },
            ],
          },
        ],
        toRemove: ['text'],
      },
      {
        name: 'appearance',
        toRemove: ['colors', 'fonts', 'padding', 'paddingMobile'],
      },
    ],
  },
};
</script>

<style scoped lang="scss">
.img.image-full-width {
  display: block;
}
</style>
